import React from 'react';
import Banner from '../../components/banner/Banner';
import Services from '../services/Services';
import About from '../../components/about/About';
import ServiceSection from '../../components/servicesection/ServiceSection';
import WhyChooseUs from '../../components/whychooseus/WhyChooseUs';
import OfferSection from '../../components/offersection/OfferSection';
import Testimonial from '../../components/testimonial/Testimonial';
import Blog from '../../components/blog/Blog';
import Footer from '../common/Footer';
import Header from '../common/Header';
import { Helmet } from 'react-helmet';

function Home() {
  return (
    <div>
      <Helmet>
        <title>
          Swakaaya Aesthetics – Skin, Hair & Slimming Clinic Gurgaon
        </title>
        <meta
          name='description'
          content='Swakaaya Aesthetics in Gurgaon offers advanced skin, hair, slimming and wellness treatments with expert dermatologists and modern technology.'
        />
        <meta
          name='keywords'
          content='Swakaaya Aesthetics Gurgaon, best skin clinic Gurgaon, dermatologist in Gurgaon, slimming treatment Gurgaon, hair clinic Gurgaon'
        />
        <link rel='canonical' href='https://swakaaya.com/' />

        <meta
          property='og:title'
          content='Swakaaya Aesthetics – Skin, Hair & Slimming Clinic Gurgaon'
        />
        <meta
          property='og:description'
          content='Swakaaya Aesthetics in Gurgaon offers advanced skin, hair, slimming and wellness treatments with expert dermatologists and modern technology.'
        />
        <meta property='og:url' content='https://swakaaya.com/' />
        <meta property='og:type' content='website' />
        <meta
          property='og:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />

        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='Swakaaya Aesthetics – Skin, Hair & Slimming Clinic Gurgaon'
        />
        <meta
          name='twitter:description'
          content='Swakaaya Aesthetics in Gurgaon offers advanced skin, hair, slimming and wellness treatments with expert dermatologists and modern technology.'
        />
        <meta
          name='twitter:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />
      </Helmet>
      <div className='main-wrapper'>
        {/* Header Start */}
        <Header />
        <Banner />
        <Services />
        <About />
        <ServiceSection />
        <WhyChooseUs />
        <OfferSection />
        <Testimonial />
        <Blog />
        <Footer />
      </div>
    </div>
  );
}

export default Home;
